import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { AdjustmentsPage } from './_dashboard.inventory.adjustments'

export const Route = createFileRoute('/_dashboard/inventory/adjustments/')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: AdjustmentsIndexPage,
})

function AdjustmentsIndexPage() {
  return <AdjustmentsPage selectedId={undefined} />
}
